import React from 'react'
import styled from 'styled-components'
import { TransactionalDialog } from '@jarvis.oddle/core/components/Dialog'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import { makeControlledModal } from 'src/decorators/ModalController'
import { P } from '@jarvis.oddle/core/components/Typo'

import useCustomisation from 'src/hooks/useCustomisation'

const ButtonText = styled(P).attrs(() => ({
  normalised: true,
  bold: true,
  mobileFontSize: '1rem',
  tabletFontSize: '1rem',
  desktopFontSize: '1rem',
  mobileLineHeight: '1.375rem',
  tabletLineHeight: '1.375rem',
  desktopLineHeight: '1.375rem'
}))`
  color: inherit;
`

const CheckoutExitConfirmationModal = ({  withHeader = true, modal, ...props }: {
  modal: {
    show: boolean
    onClose: () => void
    onClosed: () => void
  }
  withHeader: boolean
}) => {
  const { t } = React.useContext(TranslationContext)
  const { getSectionFromId } = useCustomisation()

  const {
    checkoutPageButtonTextColor
  } = getSectionFromId('checkoutPage').settings || {}

  if (withHeader) {
    return (
      <TransactionalDialog
        header={t('Leaving Checkout Page')}
        body={t('You will be redirected to your shopping cart. Items in your shopping cart will be saved but all payment information will be lost. Are you sure you want to proceed?')}
        confirmText={checkoutPageButtonTextColor ? (() => <ButtonText color={checkoutPageButtonTextColor}>{t('Back To Cart')}</ButtonText>) : t('Back To Cart')}
        {...props}
        {...modal}
      />
    )
  }

  return (
    <TransactionalDialog
      body={t('You will be redirected to your shopping cart. Items in your shopping cart will be saved but all payment information will be lost. Are you sure you want to proceed?')}
      confirmText={checkoutPageButtonTextColor ? (() => <ButtonText color={checkoutPageButtonTextColor}>{t('Back To Cart')}</ButtonText>) : t('Back To Cart')}
      {...props}
      {...modal}
    />
  )
}

export default makeControlledModal(CheckoutExitConfirmationModal, 'CheckoutExitConfirmationModal')
